<template>
  <v-modal :id="`warehouse-input-${index}`">
    <template slot="header">{{ i18nJS.conversione_magazzino }}</template>
    <form class="form-horizontal">
      <div class="control-group field">
        <label class="control-label">{{ i18nJS.um_somm }}</label>
        <div :class="['controls', selectObbligatoria]">
          <v-select2
            class="input-mini"
            :name="`guest_drug[infusion_therapies_attributes][${index}][um_somm]`"
            :element_id.sync="therapy['um_somm']"
            v-model="therapy['um_somm']"
            :element_description.sync="therapy['get_um_somm']"
            :options-list="umSommOptions"
          />
        </div>
      </div>
      <div class="control-group field">
        <label class="control-label">{{ i18nJS.qta_tot_label }}</label>
        <div :class="['controls', inputObbligatorio]">
          <input
            type="text"
            class="input-small"
            v-model="therapy['qta_tot']"
            :name="`guest_drug[infusion_therapies_attributes][${index}][qta_tot]`"
          />
          {{ therapy['get_um_somm'] }}
        </div>
      </div>
      <div class="control-group field">
        <label class="control-label">{{ i18nJS.somm_form_label }}</label>
        <div :class="['controls', selectObbligatoria]">
          <v-select2
            class="input-xlarge"
            :element_id.sync="therapy['somm_form']"
            v-model="therapy['somm_form']"
            :element_description.sync="therapy['get_somm_form']"
            :name="`guest_drug[infusion_therapies_attributes][${index}][somm_form]`"
            :options-list="sommFormOptions"
          />
        </div>
      </div>
      <div class="control-group field">
        <label class="control-label">1 {{ therapy['get_somm_form'] }}= </label>
        <div :class="['controls', inputObbligatorio]">
          <input
            type="text"
            class="input-mini"
            v-model="therapy['val_conv']"
            :name="`guest_drug[infusion_therapies_attributes][${index}][val_conv]`"
          />
          {{ therapy['get_um_somm'] }}
        </div>
      </div>
    </form>
  </v-modal>
</template>
<script>
import vSelect2 from '../vSelect2';
import vModal from '../vModal';

export default {
  name: 'infusionModal',
  props: ['infusion', 'index', 'umSommOptions', 'sommFormOptions', 'principioAttivo'],
  components: {
    vSelect2,
    vModal,
  },
  data() {
    return {
      therapy: this.infusion,
    };
  },
  computed: {
    selectObbligatoria() {
      if (!this.principioAttivo) {
        return 'mychzn-obbligatorio';
      } else {
        return 'mychzn';
      }
    },
    inputObbligatorio() {
      if (!this.principioAttivo) return 'obbligatorio';
      return '';
    },
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    eventBus.$on('openModalWharehouseTherapy', (index) => $('#warehouse-input-' + index).modal('show'));
  },
};
</script>
